export const setBackgrounds = (backgrounds) => ({
    type: "SET_BACKGROUNDS",
    backgrounds
});